import { render } from "./CxMessageForm.vue?vue&type=template&id=62c04c4f"
import script from "./CxMessageForm.vue?vue&type=script&lang=js"
export * from "./CxMessageForm.vue?vue&type=script&lang=js"

import "./CxMessageForm.vue?vue&type=style&index=0&id=62c04c4f&lang=less"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__